import { render, staticRenderFns } from "./corner.vue?vue&type=template&id=384ac911&scoped=true&lang=pug&"
var script = {}
import style0 from "./corner.vue?vue&type=style&index=0&id=384ac911&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384ac911",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('384ac911', component.options)
    } else {
      api.reload('384ac911', component.options)
    }
    module.hot.accept("./corner.vue?vue&type=template&id=384ac911&scoped=true&lang=pug&", function () {
      api.rerender('384ac911', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/floating_editor/resizer/component/corner.vue"
export default component.exports